import { InputBase_v2 } from './InputBase_v2';
import { applyMask } from '../libs/serial-number-mask';

export const InputSerialNumber = {
	functional: true,
	props: {
		mask: {
			type: String,
			default: '',
		},
		value: {
			type: String,
			default: '',
		},
	},
	render(h, {
		props,
		listeners,
		data: {
			on: {
				input,
				...on
			},
			...data
		},
	}) {
		return (
			<InputBase_v2
				{ ...{ on, ...data } }
				value={ props.value }
				vOn:input={ (value, event) => {
					const newValue = applyMask(props.mask, value);

					event.currentTarget.value = newValue;
					listeners.input?.(newValue);
				}}
			/>
		)
	}
}
